export default __webpack_public_path__ + "static/media/MyBox.75ef1f28.png";